export enum Role {
  USER = "user",
  MERCHANT = "merchant"
}

export enum PaymentChannel {
  MIXIN = "mixin",
  FOXONE = "foxone"
}

export enum AuthSource {
  MIXIN = "mixin",
  FOXONE = "foxone"
}

export enum MerchantStatus {
  ACTIVE = "active",
  IN_ACTIVE = "inactive"
}

export enum UserStatus {
  ACTIVE = "active",
  IN_ACTIVE = "inactive"
}

// scheme enums
export enum SchemeType {
  CURRENT = "current",
  POOL = "pool",
  NODE = "node",
  TERM = "term",
  DUAL_NODE = "dualnode"
}

export enum SchemeStatus {
  DRAFT = "draft",
  ONLINE = "online",
  OFFLINE = "offline"
}

export enum QuitMode {
  WITHDRAW = "withdraw",
  ASSIGN = "assign"
}

// contract enums
export enum ContractStatus {
  SIGNED = "signed",
  RUNNING = "running",
  SETTLEMENT = "settlement",
  REDEMPTION = "redemption",
  CLOSED = "closed"
}

export enum OrderStatus {
  UNPAID = "unpaid",
  PAID = "paid",
  CANCELD = "canceled",
  UNKNOWN = "unknown"
}

export enum WithdrawRequestStatus {
  PENDING = "pending",
  FAIL = "fail",
  DONE = "done"
}

// 利率类型
export enum InterestType {
  STATIC = "static",
  DYNAMIC = "dynamic"
}

// 收益模式
export enum RevenueMode {
  COMPOUND = "compound",
  SINGLE = "single"
}

// 交易记录
export enum TransactionType {
  ORDER = "order",
  REFUND = "refund",
  WITHDRAW = "withdraw",
  TRANSFER = "transfer",
  INCOME = "income",
  RETURN = "return",
  INTEREST = "interest",
  DEFAULT = "default",
  LIQUIDATION = "liquidation"
}

export enum TransactionStatus {
  PENDING = "pending",
  FAIL = "fail",
  SUCCESS = "success"
}

export enum SchemeProgress {
  PRE_OPEN = "preopen",
  OPENING = "opening",
  FULL = "full",
  RUNNING = "running",
  CLOSED = "closed"
}
